import { Box, Typography, RadioGroup, FormControlLabel, Radio, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useState, useEffect, useRef } from "react";

interface PlatformTypeProps {
    config: any;   
}

const PlatformType = ( { config }: PlatformTypeProps) => {
    console.log("configin Platfrom Type", config)
    const [cloudType, setCloudType] = useState(config);

    return (
        <Box height={'500px'}>

            <Grid size={{ xs: 12, md: 6 }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 400, color: "#E2E3E3", fontSize: 14 }}>
                    Platform Type
                </Typography>
                <Box sx={{ mb: 2, mt: 1 }} style={{ backgroundColor: "#293236", borderRadius: "30px", color: "#E2E3E3", fontSize: "14px" }}>

                    <RadioGroup
                        name="validity"
                        row
                        value={cloudType}
                        onChange={(e: any) => setCloudType(e.target.value)}
                        
                    >
                        <FormControlLabel value="1" control={<Radio disabled />} label="Public Cloud" sx={{'& .MuiFormControlLabel-label.Mui-disabled': {color: '#E2E3E3'}}} />
                        <FormControlLabel value="2" control={<Radio disabled/>} label="Private Cloud" sx={{'& .MuiFormControlLabel-label.Mui-disabled': {color: '#E2E3E3'}}}/>
                    </RadioGroup>
                </Box>
            </Grid>

            <Grid size={{ xs: 12 }}>
                <hr
                    style={{
                        border: "none",
                        height: "1px",
                        color: "#313838",
                        backgroundColor: "#313838",
                        margin: "30px 0 30px 0",
                    }}
                />
            </Grid>

            <Box sx={{ mt: 2, p: 2, borderRadius: "8px" }}>
                <Typography sx={{ color: "#B4B7B8", fontSize: "14px", whiteSpace: "pre-line" }}>
                    {`* Public Cloud is for Platforms that will have access to the internet with Port 443 open
                        * Private Cloud is for Platforms that will not have access to the internet. Private Cloud installations will have limitations:
                        1. No reCAPTCHA
                        2. No Channel Support in Views for external URL integrations
                        3. No Google Map Support
                        4. No Vault Support
                        5. Manual software updates
                        6. No Webhook support (Slack, Teams, others)
                        7. No MFA (Multi-Factor Authentication)
                        8. No Chat
                        9. No Export Clips, Share Link, other are limited to local area`}
                </Typography>
            </Box>




        </Box>
    );
};

export default PlatformType;